import React from 'react';
import { Tree } from 'primereact/tree';

const TreeComponent = ({
  data,
  onSelectionChange,
  selectedKeys,
  setSelectedKeys,
}) => {
  const getSelectedLeafNodes = (nodes, selectedKeys) => {
    const selectedLeafs = [];

    const traverse = (node) => {
      // Check if this node is selected
      if (selectedKeys?.[node.key]?.checked) {
        // If it's a leaf node (no children), add it to our results
        if (!node.children || node.children.length === 0) {
          selectedLeafs.push({
            url: node.label,
            components: node.info?.components,
            contextId: node.info?.contextId,
          });
        }
      }

      // Recursively check children
      if (node.children) {
        node.children.forEach(traverse);
      }
    };

    // Process all root nodes
    nodes.forEach(traverse);
    return selectedLeafs;
  };

  const handleSelectionChange = (e) => {
    setSelectedKeys(e.value);

    // Get all selected leaf nodes
    const selectedLeafs = getSelectedLeafNodes(data, e.value);

    // Call the parent's callback with selected leaf nodes
    onSelectionChange(selectedLeafs);
  };

  return (
    <div className='card'>
      <Tree
        value={data}
        selectionMode='checkbox'
        className='w-full md:w-30rem'
        selectionKeys={selectedKeys}
        onSelectionChange={handleSelectionChange}
      />
    </div>
  );
};

export default TreeComponent;
